import type { TFunction } from "i18next";
import { writable, derived } from "svelte/store";
import { t } from "./localization";

let translation: TFunction;
t.subscribe((v) => (translation = v));

export const notifications = createNotificationsStore();

type NotificationType = "ERROR" | "INFO" | "SUCCESS" | "CONFIRM";

function createNotificationsStore() {
	const { subscribe, update, set } = writable<
		{ type: NotificationType; message: string; id?: string; title?: string, callback?: () => {} }[]
	>([]);

	let $t: (key: string) => string;
	t.subscribe((v) => ($t = v));

	// primitives

	function clear() {
		set([]);
	}

	function append(
		type: NotificationType,
		message: string,
		id?: string,
		replace?: boolean,
		title?: string,
		timeout?: number,
		callback?: () => {}
	) {
		update((n) => {
			const newNotification = { type, message, id, title, callback };

			if (timeout) {
				setTimeout(() => {
					update((n) => {
						const elIdx = n.findIndex((v) => v === newNotification);
						if (elIdx === -1) return n;
						n.splice(elIdx, 1);
						return n;
					});
				}, timeout);
			}

			if (!id) {
				n.push(newNotification);
				return n;
			}

			const idx = n.findIndex((v) => v.id === id);

			if (replace && idx >= 0) {
				n[idx] = newNotification;
				return n;
			}

			if (callback) {
				console.log(newNotification)
				n.push(newNotification)
				return n
			}

			if (idx >= 0) n.splice(idx, 1);
			n.push(newNotification);

			return n;
		});
	}

	function remove(idx: number) {
		update((n) => {
			n.splice(idx, 1);
			return n;
		});
	}

	// helpers

	function error(message: string) {
		return function appendError() {
			append("ERROR", message);
		};
	}

	function success(message: string) {
		return function appendSuccess() {
			append("SUCCESS", message, undefined, undefined, undefined, 3000);
		};
	}

	function confirm(idx: number, callback: () => {}) {
		remove(idx)
		callback()
	}

	function defaultHandler(e: Error) {
		if (e.message === "Network Error") {
			append("ERROR", translation("hub.app.network_error"), "NETWORK");
			return;
		}

		if (e.message === "WrongFormatError") {
			append("ERROR", translation("hub.app.format_error"));
			return;
		}

		throw e;
	}

	return { subscribe, clear, append, remove, error, success, defaultHandler, confirm };
}
